export default __webpack_public_path__ + "static/SR USA - Vegan - Statement-43a0ea838424e4ae96e756a058610828.pdf";